import { ListDivider, ListHeadline } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';

export const DividerAccountListItem = ({ textKey }: { textKey: Mews.TextKey }) => (
    <>
        <ListDivider />
        <ListHeadline>
            <LocalizedText textKey={textKey} />
        </ListHeadline>
    </>
);
